<template>
  <div class="greeting-detail-container px-0" v-if="homes">
    <div class="greeting-detail-header">
      <h5 class="title my-0" v-if="user">{{ user.fullname }}</h5>
      <div v-if="user">
        <span>{{ user.verifiedDate | moment-full }} {{ " " }}</span>
        <span>{{ $t("feature.greeting.ownership") }}{{ " " }}</span>
        <span>{{ homes.length }}{{ " " }}</span>
        <span>{{ $t("feature.greeting.project") }}{{ " " }}</span>
      </div>
    </div>
    <div class="scrollable">
      <people :people="user" role="owner"></people>
      <div class="projects" v-if="newJoinProject && newJoinProject.length > 0">
        <h3>{{ $t("feature.greeting.join_project") }}</h3>
        <div class="">
          <div
            class="project d-flex"
            v-for="(home, i) in newJoinProject"
            :key="home.homeId"
            :class="{
              active: i === selectedIndex && selectedType === 'join_project'
            }"
          >
            <div class="image">
              <img
                v-if="home.project.projectIcon"
                :src="home.project.projectIcon"
              />
            </div>
            <div class="info">
              <h5>บ้านเลขที่ {{ home.addressNo }}</h5>
              <span>{{ home.project.projectName }}</span>
            </div>
            <div class="code">
              {{ home.project.projectCode }}
            </div>
            <a
              class="message"
              @click="onClickNewMessage(home, 'join_project', i)"
            >
              <img src="/static/icons/send.svg" />
            </a>
          </div>
        </div>
      </div>
      <div class="projects" v-if="greetedProject && greetedProject.length > 0">
        <h3>{{ $t("feature.greeting.greeted_project") }}</h3>
        <div class="">
          <div
            class="project d-flex"
            v-for="(home, i) in greetedProject"
            :key="home.homeId"
            :class="{
              active: i === selectedIndex && selectedType === 'greeted_project'
            }"
          >
            <div class="image">
              <img
                v-if="home.project.projectIcon"
                :src="home.project.projectIcon"
              />
            </div>
            <div class="info">
              <h5>บ้านเลขที่ {{ home.addressNo }}</h5>
              <span>{{ home.project.projectName }}</span>
            </div>
            <div class="code">
              {{ home.project.projectCode }}
            </div>
            <a
              class="message"
              @click="onClickNewMessage(home, 'greeted_project', i)"
            >
              <img src="/static/icons/send.svg" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="contactId" class="reply-container">
      <reply-box
        :contact-id="contactId"
        :homeId="homeId"
        :projectId="projectId"
        :title="messageBoxTitle"
        @message-send-success="onMessageSendSuccess"
        @message-close="onMessageBoxClose"
        type="greeting"
      ></reply-box>
    </div>
  </div>
</template>
<script>
import People from "@/components/admin/view/member/People";
import ReplyBox from "@/components/admin/view/contact/ReplyBox";
export default {
  props: {
    homes: {
      type: Array
    },
    greetings: {
      type: Array
    }
  },
  components: {
    People,
    ReplyBox
  },
  computed: {
    userId() {
      return this.$route.params.userId || null;
    },
    user() {
      if (this.greetings && this.userId) {
        // clone new object to avoid greetings list from parent disappear
        const greetings = this.greetings.slice(0);
        let user = greetings.find(member => {
          return member.userId == parseInt(this.userId);
        });
        if (user) {
          user = {
            fullname: `${user.firstName} ${user.lastName}`,
            // isActive: true,
            mobileNumber: user.mobileNumber,
            verifyStatus: true,
            // fullnameApp: 'sample owner1 firstname sample owner1 lastname',
            email: user.email,
            profileImage: user.imageKey,
            verifiedDate: user.verifiedDate
          };
          return user;
        }
      }
      return null;
    },
    newJoinProject() {
      return this.homes.filter(home => !home.greeted);
    },
    greetedProject() {
      return this.homes.filter(home => home.greeted);
    }
  },
  data() {
    return {
      contactId: null,
      homeId: null,
      projectId: null,
      messageBoxTitle: "",
      selectedIndex: null,
      selectedType: null,
      image: null,
      people: {
        fullname: "sdfsdf sdf",
        email: "oatkung@gmail.com",
        mobileNumber: "0943023034",
        name: "sdfsdf",
        verifyStatus: true
      }
    };
  },
  watch: {
    $route() {
      this.onMessageBoxClose();
    }
  },
  methods: {
    onClickNewMessage(home, type, index) {
      this.messageBoxTitle = home.project.projectName;
      this.contactId = this.userId;
      this.projectId = home.project.projectId;
      this.homeId = home.homeId;
      this.selectedIndex = index;
      this.selectedType = type;
      localStorage.setItem("projectId", home.project.projectId);
      localStorage.setItem("projectName", home.project.projectName);
      localStorage.setItem("projectIcon", home.project.projectIcon);
      this.$store.commit("setProjectName", home.project.projectName);
      this.$store.commit("setProjectId", home.project.projectId);
    },
    onMessageBoxClose() {
      this.messageBoxTitle = "";
      this.contactId = null;
      this.projectId = null;
      this.homeId = null;
      this.selectedIndex = null;
      this.selectedType = null;
    },
    onMessageSendSuccess({ topicId }) {
      this.$router.push({ name: "Contact", params: { contactId: topicId } });
    }
  }
};
</script>
<style lang="scss" scoped>
.greeting-detail-container {
  background: white;
  .greeting-detail-header {
    border-bottom: 1px solid#e0e0e0;
    padding: 10px 13px;
    h5 {
      font-size: 16px;
      font-weight: bold;
      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
    span {
      color: #4a4a4a;
      font-size: 11px;
      font-weight: 500;
    }
  }
  .projects {
    h3 {
      padding: 9px 16px;
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.38;
      background: #f9f9f9;
      color: #000000;
      margin: 0;
    }
    .project {
      padding: 13px 16px;
      border: solid 1px #f5f5f5;
      &.active {
        background: #efefef;
      }
      .image {
        width: 36px;
        height: 36px;
        margin-right: 20px;
        border-radius: 15px;
        border: #ccc 1px solid;
        overflow: hidden;
        background: #eee;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .info {
        flex: 1;
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        color: #000000;
        h5 {
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.38;
          margin: 0;
        }
      }
      .code {
        padding: 0 20px;
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        color: #000000;
        align-self: center;
      }
      .message {
        display: block;
        cursor: pointer;
        // align-self: center;
        img {
          width: 46px;
        }
      }
    }
  }
  .scrollable {
    overflow: auto;
    flex: 1;
  }
  .reply-container {
    flex: 0 0 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/greeting/GreetingDetail.vue